import useLocales from '@hooks/useLocales';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { CustomModal } from './CustomModal';

export const MindgageScoresTooltip = ({ open, onClose }: any) => {
  const { t } = useLocales();
  const rows = [
    { score: 1, natural: t('Very low') },
    { score: 2, natural: t('Low') },
    { score: 3, natural: t('Average') },
    { score: 4, natural: t('High') },
    { score: 5, natural: t('Very high') }
  ];
  return (
    <CustomModal open={open} onClose={onClose}>
      <Typography variant="h3" gutterBottom>
        {t('Mindgage Score Information')}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t('Please contact us if you have any questions')}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('Score')}</TableCell>
            <TableCell align="right">{t('Natural ability')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row: any) => (
            <TableRow key={row.score}>
              <TableCell>{row.score}</TableCell>
              <TableCell align="right">{row.natural}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CustomModal>
  );
};

